// The "Stats" filters live in the URL (?tab=stats&status=given&from=…) like the issued list's,
// sharing its date and manager keys; the status differs (the stats default to every comp given
// away: all but cancelled) and there is no player filter (the top players table is per player).
import { ALL_MANAGERS, managerParam } from './issuedList';
import { filtersFromSearch, searchWithoutFilters } from './issuedFilters';

export const STATS_STATUS_FILTERS = [
  { key: 'given', label: 'Given away' },
  { key: 'all', label: 'All' },
];

const DEFAULT_STATUS = 'given';
const STATUSES = STATS_STATUS_FILTERS.map((f) => f.key);
// DEFAULT_DAYS: without dates the stats cover the last week (today included), so an unfiltered
// view never sums the whole table.
export const DEFAULT_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

// defaultRange: the last DEFAULT_DAYS UTC days up to now.
export const defaultRange = (now = Date.now()) => ({
  from: new Date(now - (DEFAULT_DAYS - 1) * DAY_MS).toISOString().slice(0, 10),
  to: new Date(now).toISOString().slice(0, 10),
});

// statsFiltersFromSearch reads the stats filters from the URL; an unknown status is "given" and
// no dates at all is the default range (one date alone is kept open-ended).
export const statsFiltersFromSearch = (searchParams, now = Date.now()) => {
  const { from, to, manager } = filtersFromSearch(searchParams);
  const raw = searchParams.get('status');
  const dates = from || to ? { from, to } : defaultRange(now);
  return { status: STATUSES.includes(raw) ? raw : DEFAULT_STATUS, ...dates, manager };
};

// searchWithStatsFilters returns a copy of the query holding the filters: the status always, the
// rest only when they narrow the stats.
export const searchWithStatsFilters = (searchParams, filters) => {
  const next = searchWithoutFilters(searchParams);
  next.set('status', filters.status);
  if (filters.from) next.set('from', filters.from);
  if (filters.to) next.set('to', filters.to);
  if (filters.manager !== ALL_MANAGERS) next.set('manager', filters.manager);
  return next;
};

export const searchWithStatsPatch = (searchParams, patch) => (
  searchWithStatsFilters(searchParams, { ...statsFiltersFromSearch(searchParams), ...patch })
);

// statsQuery: the API params for the filters ("all" sends no status).
export const statsQuery = ({ status, from, to, manager }) => ({
  ...(status !== 'all' && { status }),
  ...(from && { from }),
  ...(to && { to }),
  ...managerParam(manager),
});
